import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { optimizationApi, type OptimizationJob } from '../../api/optimization';

export function ExecutionTimelinePage() {
  const [history, setHistory] = useState<OptimizationJob[]>([]);
  const [activity, setActivity] = useState<{ id: string; action: string; message: string; created_at: string }[]>([]);
  useEffect(() => {
    void optimizationApi.history().then(setHistory);
    void optimizationApi.activity().then(setActivity);
  }, []);
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Execution Timeline</h1>
      <Link to="/optimization" className="mt-2 inline-block text-sm text-violet-700 hover:underline dark:text-violet-400">← Optimization Center</Link>
      <div className="mt-6 grid gap-6 lg:grid-cols-2">
        <div><h2 className="font-medium">Optimization Jobs</h2><ul className="mt-3 space-y-2">{history.map((j) => (
          <li key={j.id} className="rounded border px-3 py-2 text-sm dark:border-slate-700">{j.name} · {j.status} · ${j.savings_usd ?? 0}</li>
        ))}{history.length === 0 && <p className="text-sm text-slate-500">No executions yet.</p>}</ul></div>
        <div><h2 className="font-medium">Activity</h2><ul className="mt-3 space-y-2">{activity.map((a) => (
          <li key={a.id} className="rounded border px-3 py-2 text-sm dark:border-slate-700">{a.action}: {a.message}</li>
        ))}</ul></div>
      </div>
    </div>
  );
}
